import React from 'react';
import logo from './logo.svg';
import { container } from "tsyringe";
import { Container } from "@mui/material";
import {
  Route,
  RouterProvider,
  Routes,
  ScrollRestoration,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import './App.css';
import { LandingPage } from './pages/landing_page/LandingPage';
import { AdministratorPage } from './pages/administrator/AdministratorPage';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
// import { password, username } from './user_secrets/debug';
import { LoginPage } from './pages/login_page/LoginPage';
import { UnsubscribePage } from './pages/unsubscribe_page/UnsubscribePage';
import { ReportingPage } from './pages/reporting/ReportingPage';
import { AdministratorOptionsPage } from './pages/administrator_options/AdministratorOptionsPage';
import { KeyTransferPage } from './pages/key_transfer/KeyTransferPage';

export function App() {
  // const analyticsService = container.resolve(AnalyticsService);
  // analyticsService.Initialize("G-VECM5N4S2Q");

  // if (process.env!.NODE_ENV === "development") {
  //   signInWithEmailAndPassword(auth, username, password);

  // }


  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<LandingPage />} />
        <Route path="/AdministratorPage" element={<AdministratorPage />} />
        <Route path="/LoginPage" element={<LoginPage />} />
        <Route path="/UnsubscribePage/:email" element={<UnsubscribePage />} />
        <Route path="/ReportingPage" element={<ReportingPage />} />
        <Route path="/AdministratorOptionsPage" element={<AdministratorOptionsPage />} />
        <Route path="/KeyTransferPage" element={<KeyTransferPage />} />
      </>
    )
  );

  return (
    <Container>
      <RouterProvider router={router} />
    </Container>
  );
}

export default App;
